export const DICTIONARY = {
    'h-service': {
        'ru': 'Услуги',
        'am': 'Ծառայություններ',
        'us': 'Services',
    },
    'h-price': {
        'ru': 'Стоимость',
        'am': 'Արժեք',
        'us': 'Price',
    },
    'h-about': {
        'ru': 'О компании',
        'am': 'Ընկերության մասին',
        'us': 'About us',
    },
    'h-contact': {
        'ru': 'Контакты',
        'am': 'Կոնտակտներ',
        'us': 'Contacts',
    },
    'callback-button': {
        'ru': 'Оставить заявку',
        'am': 'Հայտ թողնել',
        'us': 'Apply',
    },
    'callback-button2': {
        'ru': 'Оставить заявку',
        'am': 'Հայտ թողնել',
        'us': 'Apply',
    },
    'callback-button3': {
        'ru': 'Оставить заявку',
        'am': 'Հայտ թողնել',
        'us': 'Apply',
    },
    'callback-button4': {
        'ru': 'Оставить заявку',
        'am': 'Հայտ թողնել',
        'us': 'Apply',
    },
    'callback-button5': {
        'ru': 'Оставить заявку',
        'am': 'Հայտ թողնել',
        'us': 'Apply',
    },
    'callback-button6': {
        'ru': 'Оставить заявку',
        'am': 'Հայտ թողնել',
        'us': 'Apply',
    },
    'hero-title': {
        'ru': 'Edelweiss — <span>подбор и доставка автомобилей</span> со всего мира',
        'us': 'Edelweiss – global <span>car selection and delivery</span>',
        'am': 'Edelweiss - <span>ավտոմեքենաների ընտրություն և առաքում</span> ամբողջ աշխարհից',
    },
    'hero-text': {
        'ru': '<span>Найдем и доставим автомобиль под ключ</span> из любой точки планеты до вашего дома.',
        'us': '<span>We will search for a car and deliver it</span> from any location to your home on a turn-key basis.',
        'am': 'Կգտնենք և կառաքենք շահագործման համար լիարժեք պատրաստ մեքենա՝ մոլորակի ցանկացած կետից մինչև ձեր տուն:',
    },
    'hero-item-1': {
        'ru': 'Пройдем таможню <span>на&nbsp;льготных условиях</span>',
        'us': 'Moreover, we will provide customs clearance on favorable terms',
        'am': 'Մենք արտոնյալ պայմաններով կմաքսազերծենք',
    },
    'hero-item-2': {
        'ru': 'Поможем с&nbsp;оформлением <span>документов</span>',
        'us': 'Prepare <span>all documents</span>',
        'am': 'կօգնենք փաստաթղթերի ձևակերպմանը',
    },
    'hero-item-3': {
        'ru': ' Уложимся <span>в&nbsp;бюджет</span>',
        'us': 'Keep to <span>the budget</span>',
        'am': 'կտեղավորվենք բյուջեում',
    },


    'delivery-title': {
        'ru': 'Не теряйте времени на поиск автомобиля мечты в России',
        'us': 'Don\'t waste time searching for your dream car',
        'am': 'Մի վատնեք ձեր երազած մեքենան գտնելու ժամանակը',
    },
    'delivery-description': {
        'ru': 'Компания Edelweiss доставит любой автомобиль из США, Азии, Европы и других частей света.',
        'us': 'Edelweiss delivers cars from the USA, Asia, Europe and other parts of the world.',
        'am': 'Edelweiss ընկերությունը ցանկացած մեքենա կառաքի ԱՄՆ-ից, Ասիայից, Եվրոպայից և աշխարհի այլ մասերից։',
    },
    'delivery-info-title1': {
        'ru': 'Новый авто',
        'us': 'New cars',
        'am': 'Նոր',
    },
    'delivery-info-desc1': {
        'ru': 'Подберем и доставим авто <span>от более 50&nbsp;производителей</span>',
        'us': 'We will select and deliver cars <span>from over 50&nbsp;manufactures</span>',
        'am': 'Մենք կընտրենք և կառաքենք ավելի քան <span>50&nbsp;արտադրողների մեքենաներ</span>',
    },
    'delivery-info-title2': {
        'ru': 'Авто с пробегом',
        'us': 'Used cars',
        'am': 'Օգտագործված',
    },
    'delivery-info-desc2': {
        'ru': '<span>Привезем автомобиль,</span> проверенный временем',
        'us': '<span>We will deliver a reliable car.</span>',
        'am': '<span>Կբերենք ժամանակով փորձարկված մեքենաներ</span>',
    },
    'delivery-info-title3': {
        'ru': 'Авто по бюджету',
        'us': 'Budget',
        'am': 'Ըստ բյուջեի',
    },
    'delivery-info-desc3': {
        'ru': 'Установите допустимый бюджет, <br> <span>а мы займемся поиском, доставкой и другими заботами</span>',
        'us': 'Set a budget,<span> and we\'ll start searching, delivering and doing other issues.</span>',
        'am': '<span>Սահմանեք ընդունելի բյուջե և մենք կզբաղվենք որոնմամբ, առաքմամբ և այլ հոգսերով</span>',
    },


    'advantages-title1': {
        'ru': 'Составим бюджет',
        'us': 'Budget estimate',
        'am': 'Կկազմենք  բյուջե',
    },
    'advantages-text1': {
        'ru': 'Сотрудники Edelweiss рассчитают бюджет, начиная с поиска и доставки, заканчивая услугами таможенного брокера.',
        'us': 'Edelweiss staff will estimate the budget for searching, delivery and customs clearance services.',
        'am': 'Edelweiss-ի աշխատակիցները կհաշվարկեն բյուջեն՝ սկսած որոնումից ու առաքումից, վերջացրած մաքսային միջնորդի ծառայություններով։',
    },
    'advantages-title2': {
        'ru': 'Прозрачность сделки',
        'us': 'Deal transparency',
        'am': 'Գործարքի թափանցիկություն',
    },
    'advantages-text2': {
        'ru': 'Заключим официальный договор. Поставим автомобиль из зарубежного дилерского центра или с надежного аукциона.',
        'us': 'We will conclude a formal contract. We will deliver a car from a foreign dealer or a reliable car auction.',
        'am': 'Կկնքենք պաշտոնական պայմանագիր։ Մեքենան կմատակարարենք արտասահմանյան դիլերից կամ հուսալի աճուրդից։',
    },
    'advantages-title3': {
        'ru': 'Поддержка 24/7',
        'us': '24/7 customer support',
        'am': 'Աջակցություն 24/7',
    },
    'advantages-text3': {
        'ru': 'С вами будет поддерживать связь персональный менеджер, готовый ответить на вопросы в любое время.',
        'us': 'A personal assistant will be in touch with you and ready to answer questions at any time.',
        'am': 'Անձնական մենեջերը կապի մեջ կլինի ձեզ հետ՝ պատրաստ ցանկացած պահի պատասխանել հարցերին:',
    },
    'advantages-title4': {
        'ru': 'Доставляем <br> по&nbsp;адресу',
        'us': 'Delivery to your address',
        'am': 'Առաքում հասցեով',
    },
    'advantages-text4': {
        'ru': 'Вы сами решаете, где заберете автомобиль: на таможне или у подъезда.',
        'us': 'It’s up to you where you pick up the car: at customs or at your home entrance.',
        'am': 'Դուք ինքներդ եք որոշում, թե որտեղ եք վերցնելու մեքենան՝ մաքսատանը թե տան մուտքի մոտ։',
    },
    'advantages-title5': {
        'ru': 'Сэкономим ваше <br> время и деньги',
        'us': 'Save your money and time',
        'am': 'Կխնայենք ձեր ժամանակը և գումարը',
    },
    'advantages-text5': {
        'ru': 'Edelweiss позаботится о том, чтобы вам не пришлось доплачивать за растаможку, поиск автомобиля или доставку. Мы сделаем точный расчет стоимости сделки.',
        'us': 'Edelweiss will make necessary arrangements to prevent you from paying extra for customs clearance, car searching or delivery. We will make a precise calculation of the contract price.',
        'am': 'Edelweiss-ը կհոգա, որ դուք ստիպված չլինեք հավելյալ վճարել մաքսազերծման, մեքենայի որոնման կամ առաքման համար։ Մենք կկատարենք գործարքի արժեքի ճշգրիտ հաշվարկ:',
    },
    'advantages-title6': {
        'ru': 'Предоставим отчет',
        'us': 'Reporting',
        'am': 'Կտրամադրեենք հաշվետվություն',
    },
    'advantages-text6': {
        'ru': 'Каждый этап работы над доставкой вашего автомобиля будет подкрепляться фотоотчетом от персонального менеджера.',
        'us': 'A personal assistant will provide you with the photo report on each stage of the car delivery.',
        'am': 'Ձեր մեքենայի առաքման աշխատանքների յուրաքանչյուր փուլ կամրապնդվի անձնական մենեջերի ֆոտոհաշվետվությամբ:',
    },
    'advantages-title': {
        'ru': 'Подбор и доставка автомобилей без границ',
        'us': 'Car selection and delivery without borders',
        'am': 'Ավտոմեքենաների ընտրություն և առաքում առանց սահմանների',
    },
    'advantages-text': {
        'ru': 'Специалисты компании Edelweiss найдут и доставят нужную модель до вашего подъезда',
        'us': 'The Edelweiss experts will find the required car model and deliver it to your home.',
        'am': 'Edelweiss ընկերության մասնագետները կգտնեն և կհասցնեն անհրաժեշտ մոդելը մինչև ձեր տան  մուտք',
    },


    'services-title': {
        'ru': 'Все необходимое в&nbsp;быстром доступе',
        'us': 'Everything you need is within reach',
        'am': 'Այն ամենը, ինչ հարկավոր է արագ մուտքի համար',
    },
    'services-text': {
        'ru': '<span>Мы практикуем комплексный подход к сделке.</span> Вы можете заказать не только поиск и&nbsp;доставку автомобиля, но и его техническое обслуживание в СТО наших партнеров.',
        'us': '<span>We adhere to integrated approach.</span> You can order the car search and delivery, as well as its maintenance at the service stations of our partners.',
        'am': '<span>Մենք կիրառում ենք համապարփակ մոտեցում գործարքին:</span> Դուք կարող եք պատվիրել ոչ միայն մեքենայի որոնում և առաքում, այլև նրա տեխնիկական սպասարկում մեր գործընկերների ՏՍԿ-ում (տեխ-սպասարկման կայան) :',
    },
    'services-item-t1': {
        'ru': 'Индивидуальные <br class="desktop"> критерии подбора',
        'us': 'Individual <br class="desktop">search criteria',
        'am': 'Անհատական <br class="desktop">ընտրության չափանիշներ',
    },
    'services-item-p1': {
        'ru': 'Вы расскажете нам о своих предпочтениях, а мы предложим варианты, которые им соответствуют.',
        'us': 'Tell us your preferences, and we will suggest options that match them.',
        'am': 'Դուք մեզ կպատմեք Ձեր նախասիրությունների մասին և մենք կառաջարկենք դրանց համապատասխան տարբերակներ:',
    },
    'services-item-t2': {
        'ru': 'Доставка, <br> без опозданий',
        'us': 'Just-in-time <br>delivery',
        'am': 'Առաքում, <br>առանց ուշացման',
    },
    'services-item-p2': {
        'ru': 'Доставим автомобиль точно в срок, в любой населенный пункт России.',
        'us': 'We will deliver your car to any location right on time.',
        'am': 'Մենք մեքենան ճիշտ ժամանակին կհասցնենք ցանկացած տեղանք։',
    },
    'services-item-t3': {
        'ru': 'Качественное <br> обслуживание',
        'us': 'High quality<br> services',
        'am': 'Որակյալ<br> սպասարկում',
    },
    'services-item-p3': {
        'ru': 'Мы найдем оригинальные запасные части и выполним ремонт в надежном автосервисе.',
        'us': 'We will find original spare parts and repair the car at a reliable service station.',
        'am': 'Մենք կգտնենք օրիգինալ պահեստամասեր և կվերանորոգենք հուսալի ավտոտեխսպասարկման կայանում։',
    },


    'maintenance-title': {
        'ru': 'Техническое обслуживание и поиск запчастей',
        'us': 'Maintenance and spare parts',
        'am': 'Տեխնիկական սպասարկում և պահեստամասերի որոնում',
    },
    'maintenance-text': {
        'ru': 'К некоторым автомобилям непросто найти оригинальные запасные части в России.<br> Поэтому мы предлагаем: <span>Услугу поиска комплектующих и ремонт в партнерских центрах.</span>',
        'us': 'It is not easy to find original spare parts for some cars. Therefore, our services include spare parts searching and repairing works at the partners’ centers.',
        'am': 'Որոշ մեքենաների համար հեշտ չէ գտնել օրիգինալ պահեստամասեր։<br> Հետևաբար, մենք առաջարկում ենք պահեստամասերի որոնման և վերանորոգման ծառայություն գործընկեր կենտրոններում:',
    },

    'steps-title': {
        'ru': 'Девять этапов покупки автомобиля в Edelweiss',
        'us': 'Nine stages of car buying at Edelweiss',
        'am': 'Edelweiss-ում մեքենա գնելու ինը փուլեր',
    },
    'steps-subtitle': {
        'ru': 'Ваш персональный менеджер проследит за тем, чтобы каждый из 9 пунктов был выполнен на 100%.',
        'us': 'Your personal assistant will ensure that each of 9 stages is 100% fulfilled.',
        'am': 'Ձեր անձնական մենեջերը կհետևի, որ 9 կետերից յուրաքանչյուրը 100% -ով կատարվի:',
    },
    'step-h1': {
        'ru': 'Индивидуальный подход',
        'us': 'Customized approach',
        'am': 'Անհատական մոտեցում',
    },
    'step-p1': {
        'ru': 'Мы подберем новый или подержанный автомобиль, ориентируясь на ваши критерии.',
        'us': 'We will select a new or a used car based on your criteria.',
        'am': 'Մենք կընտրենք նոր կամ օգտագործված մեքենա՝ ելնելով ձեր չափանիշներից:',
    },
    'step-h2': {
        'ru': 'Оценка и расчет стоимости',
        'us': 'Price calculation',
        'am': 'Գնահատում և արժեքի հաշվարկ',
    },
    'step-p2': {
        'ru': 'Мы рассчитаем все затраты на сделку и предоставим подробную смету. <br><span>Если вас всё устроит, заключим договор.</span>',
        'us': 'We will estimate all costs and provide a detailed cost sheet.<br><span> If you are satisfied with the price, we will conclude a contract.</span>',
        'am': 'Մենք կհաշվարկենք գործարքի բոլոր ծախսերը և կտրամադրենք մանրամասն նախահաշիվ:<br><span> Եթե ձեզ ամեն ինչ բավարարի, կկնքենք պայմանագիր։</span>',
    },
    'step-h3': {
        'ru': 'Удобная оплата',
        'us': 'Favorable payment terms',
        'am': 'Հարմար վճարում',
    },
    'step-p3': {
        'ru': 'Мы поможем провести оплату автомобиля в долларах, через систему SWIFT.<br><span>Гарантируем, что с переводом не возникнет трудностей.</span>',
        'us': 'You can pay in US dollars through the SWIFT payment system.<br><span> We guarantee no problems with wire transfers.</span>',
        'am': 'Մենք կօգնենք մեքենայի համար վճարել դոլարով՝ SWIFT համակարգի միջոցով։ <br><span> Երաշխավորում ենք, որ փոխանցման հետ կապված դժվարություններ չեն լինի։</span>',
    },
    'step-h4': {
        'ru': 'Комплексная подготовка автомобиля',
        'us': 'Full car preparation',
        'am': 'Մեքենայի համալիր պատրաստում',
    },
    'step-p4': {
        'ru': 'Если вы закажете поврежденный автомобиль со страхового аукциона, мы приведем его в порядок и доставим в идеальном состоянии.',
        'us': 'If you order a damaged car from salvage auto auctions, we will repair it and deliver in mint condition.',
        'am': 'Ապահովագրության աճուրդից վնասված մեքենա պատվիրելու դեպքում մենք այն կվերանորոգենք և կմատուցենք ձեզ իդեալական վիճակում։',
    },
    'step-h5': {
        'ru': 'Доставка в российский порт от 1 до 3 месяцев',
        'us': '1 to 3 months delivery to port',
        'am': 'Առաքում նավահանգիստ 1-ից 3 ամիս',
    },
    'step-p5': {
        'ru': 'Автомобиль придет в порт после оплаты и всех необходимых подготовительных процессов.<br><span>Вам не придется ждать дольше трех месяцев.</span>',
        'us': 'The car will be delivered to a port after the payment is made and all preparation procedures are completed.<br><span> There is no need to wait for more than three months.</span>',
        'am': 'Մեքենան նավահանգիստ կգա վճարումից և բոլոր անհրաժեշտ նախապատրաստական գործընթացներից հետո։<br><span> Դուք ստիպված չեք լինի սպասել երեք ամսից ավելի:</span>',
    },
    'step-h6': {
        'ru': 'Выгодное <br> прохождение таможни',
        'us': 'Favorable terms<br> for customs clearance',
        'am': 'Շահավետ<br> մաքսազերծում',
    },
    'step-p6': {
        'ru': 'Мы всегда стараемся сделать так, чтобы автомобили наших клиентов проходили таможню на льготных условиях.',
        'us': 'We always try our best to ensure the most favorable terms for customs clearance of our customers’ cars.',
        'am': 'Մենք միշտ փորձում ենք այնպես անել, որ մեր հաճախորդների մեքենաները մաքսազերծվեն արտոնյալ պայմաններով։',
    },
    'step-h7': {
        'ru': 'Получение документов и сертификация',
        'us': 'Documentation and certification',
        'am': 'Փաստաթղթերի ստացում և սերտիֆիկացում',
    },
    'step-p7': {
        'ru': 'Вручим полный пакет документов, включая сертификат о безопасности. <span>Установим ГЛОНАСС, поможем получить ПТС в электронном виде.</span>',
        'us': 'We will provide you with a full package of documents, including safety certificate.<span> We will install GLONASS autonomous unit and help to obtain an electronic Vehicle License.</span>',
        'am': 'Մենք կտրամադրենք փաստաթղթերի ամբողջական փաթեթ, ներառյալ անվտանգության սերտիֆիկատը: <span>Մենք կտեղադրենք GLONASS-ը, կօգնենք էլեկտրոնային եղանակով ստանալ ՏՄՎ (Տրանսպորտային միջոցի վկայական):</span>',
    },
    'step-h8': {
        'ru': 'Помощь <br> в постановке на учет',
        'us': 'Car registration<br> assistance',
        'am': 'Աջակցություն գրանցման<br> հարցում',
    },
    'step-p8': {
        'ru': 'Наши специалисты помогут поставить автомобиль на учет в ГИБДД, если в этом возникнет необходимость.',
        'us': 'Our experts can help you to register a car with the State Authority for Road Traffic Safety, if necessary.',
        'am': 'Մեր մասնագետները անհրաժեշտության դեպքում կօգնեն մեքենան գրանցել ճանապարհային ոստիկանությունում։',
    },
    'step-h9': {
        'ru': 'Доставка <br> в любой город РФ',
        'us': 'Delivery<br> to any city',
        'am': 'Առաքում<br> ցանկացած քաղաք',
    },
    'step-p9': {
        'ru': 'Привезем автомобиль в любой город нашей страны. Вы сами выбираете конечную точку доставки.',
        'us': 'We will deliver the car to any city in this country. You may choose the place of destination.',
        'am': 'Մենք մեքենան կբերենք մեր երկրի ցանկացած քաղաք: Դուք ինքներդ եք ընտրում առաքման վերջնական կետը:',
    },


    'price-title': {
        'ru': 'Как формируется бюджет на покупку автомобиля',
        'us': 'How to draw up the budget for the car buying',
        'am': 'Ինչպես է ձևավորվում մեքենայի գնման բյուջեն',
    },
    'price-item1-text-1': {
        'ru': 'Стоимость авто',
        'us': 'Car price',
        'am': 'Մեքենայի արժեքը',
    },
    'price-item1-text-2': {
        'ru': 'Это может быть новый автомобиль или с пробегом.<br>В первом случае, стоимость будет значительно выше.',
        'us': 'You can choose a new car or used one. The new car’s price is much higher ',
        'am': 'Դա կարող է լինել նոր կամ օգտագործված մեքենա: Առաջին դեպքում, արժեքը կլինի շատ ավելի բարձր:',
    },
    'price-item1-text-4': {
        'ru': 'Средний чек на комплекс процедур. Мы обслуживаем автомобили, заказанные со страхового аукциона.',
        'us': 'The average price of our services. We provide maintenance services to cars bought at the salvage auctions.',
        'am': 'Միջին չեկը մի շարք ընթացակարգերի համար. Մենք սպասարկում ենք ապահովագրական աճուրդից պատվիրված մեքենաներ',
    },
    'price-item1-text-5': {
        'ru': 'Улучшить комплектацию авто',
        'us': 'Install additional equipment',
        'am': 'բարվոքել մեքենայի սարքավորումները լրացուցիչ սարքավորումներով',
    },
    'price-item1-text-6': {
        'ru': 'доп. оборудование, оригинальные аксессуарами или тюнингом. Сделаем в специализированной автомастерской.',
        'us': 'add original accessories or make tuning, our specialized repair shop is at your service.',
        'am': 'օրիգինալ աքսեսուարներով կամ թյունինգով, մենք կարող ենք դա անել մեքենաների մասնագիտացված արտադրամասում։',
    },

    'price-item2-text-1': {
        'ru': 'Полное сопровождение автомобиля',
        'us': 'End-to-end support',
        'am': 'Մեքենայի ամբողջական ուղեկցում',
    },
    'price-item2-text-2': {
        'ru': 'Edelweiss проследит, чтобы авто прошел все пункты назначения в срок, по&nbsp;самым выгодным тарифам.',
        'us': 'Edelweiss will control that the car passes all points of destination on time and at most favorable rates.',
        'am': 'Edelweiss-ը կհետևի, որ մեքենան ժամանակին անցնի բոլոր նշված կետերը՝ առավել շահավետ սակագներով։',
    },
    'price-item2-text-3': {
        'ru': 'В среднем обходится доставка автомобиля в пограничный пункт России',
        'us': 'Сar delivery to a Russian border point ',
        'am': 'Ռուսաստանի սահմանային անցակետ մեքենայի առաքումը ',
    },
    'price-item2-text-4': {
        'ru': 'от 50 000 ₽',
        'us': 'from 50 000 ₽',
        'am': 'սկսած 50 000 ₽',
    },
    'price-item2-text-5': {
        'ru': 'Осуществим доставку до вашего дома, в любой город РФ.',
        'us': 'We will deliver a car to your home in any Russian city.',
        'am': 'Կառաքենք մինչև ձեր տուն, Ռուսաստանի Դաշնության ցանկացած քաղաք։',
    },
    'price-item3-text-1': {
        'ru': 'Урегулируем тонкости сделки',
        'us': 'Deal settlement',
        'am': 'Կկարգավորենք գործարքի նրբությունները',
    },
    'price-item3-text-2': {
        'ru': 'Расскажем, как сэкономить на комиссии, таможенных и регистрационных сборах',
        'us': 'We will advise you how to save money on fees, as well as customs and registration duties.',
        'am': 'Մենք ձեզ կասենք, թե ինչպես գումար խնայել միջնորդավճարների, մաքսային և գրանցման վճարների վրա:',
    },
    'price-item3-text-3': {
        'ru': '15% от стоимости авто',
        'us': '15% of the initial car price',
        'am': '15% - ը Մեքենայի արժեքի',
    },
    'price-item3-text-4': {
        'ru': 'Размер установленной таможенной пошлины от первоначальной стоимости авто',
        'us': 'The fixed customs duty of the initial car price.',
        'am': 'Սահմանված մաքսատուրքի չափը՝ ավտոմեքենայի սկզբնական արժեքի ',
    },
    'price-item3-text-5': {
        'ru': 'Услуги таможенного брокера',
        'us': 'Customs broker services',
        'am': 'Մաքսային բրոքերի ծառայությունները',
    },
    'price-item4-text-1': {
        'ru': 'Какие еще будут расходы',
        'us': 'Other expenses',
        'am': 'Ինչպիսի այլ ծախսեր կլինեն',
    },
    'price-item4-text-2': {
        'ru': 'Вы можете получить СБКТС, установить ЭРА-ГЛОНАСС, получить ПТС в электронном виде. Мы также берем комиссию за услуги.',
        'us': 'You may obtain the Motor Vehicle Safety Certificate, an electronic Vehicle License or install ERA-GLONASS system. We charge a fee for our services.',
        'am': 'Դուք կարող եք ձեռք բերել մեքենայի նախագծման անվտանգության վկայագիր, տեղադրել ERA-GLONASS, ստանալ ՏՄՎ (Տրանսպորտային միջոցի վկայական) էլեկտրոնային եղանակով: Մենք նաև գանձում ենք սպասարկման վճար։',
    },
    'price-item4-text-3': {
        'ru': 'Расходы на получение документов и сертификацию',
        'us': 'The total expenses on documentation and registrations',
        'am': 'Փաստաթղթերի ստացման և սերտիֆիկացման ծախսերը',
    },
    'price-item4-text-4': {
        'ru': '10% от стоимости договора ',
        'us': '10% of the contract price',
        'am': '10% - ը պայմանագրի արժեքի',
    },
    'price-item4-text-5': {
        'ru': 'Комиссия нашей компании',
        'us': 'The fee rate',
        'am': 'Մեր ընկերության միջնորդավճարը',
    },


    'info-title': {
        'ru': 'Давайте рассчитаем бюджет',
        'us': 'Let’s calculate the budget',
        'am': 'Եկեք հաշվարկենք բյուջեն',
    },
    'info-text': {
        'ru': 'Узнайте, какая сумма потребуется, чтобы получить автомобиль мечты',
        'us': 'Find out how much it costs to get your dream car.',
        'am': 'Իմացեք, թե որքան գումար կպահանջվի ձեր երազանքի մեքենան ձեռք բերելու համար',
    },


    'about-text': {
        'ru': '— компания, которая занимается поиском, покупкой, доставкой и техническим обслуживанием автомобилей из любой точки мира.',
        'us': 'searches, buys, delivers and maintains cars from all over the world',
        'am': '-ը ընկերություն է, որը զբաղվում է աշխարհի ցանկացած կետից մեքենաների որոնմամբ, գնմամբ, առաքմամբ և սպասարկմամբ',
    },
    'about-text2': {
        'ru': 'Мы поможем обойти все преграды',
        'us': 'We will help you to overcome all barriers',
        'am': 'Մենք կօգնենք ձեզ շրջանցել բոլոր խոչընդոտները',
    },
    'about-text3': {
        'ru': 'на пути к именно такой машине, какую вы всегда хотели.',
        'us': ' on the way to the car you\'ve always dreamt.',
        'am': 'ճանապարհին դեպի այն մեքենան, որը դուք միշտ ցանկացել եք:',
    },
    'about-text4': {
        'ru': 'Мы разбираемся в зарубежных аукционах',
        'us': ' We are familiar with the foreign auctions,',
        'am': 'Մենք հասկանում ենք արտասահմանյան աճուրդները',
    },
    'about-text5': {
        'ru': 'и имеем широкую сеть связей с зарубежными дилерскими центрами',
        'us': ' and have an extensive dealer network abroad.',
        'am': 'Եվ մենք ունենք կապերի լայն ցանց արտասահմանյան դիլերային կենտրոնների հետ',
    },
    'about-text6': {
        'ru': 'Мы знаем как пройти таможню',
        'us': ' Moreover,',
        'am': 'Մենք գիտենք, թե ինչպես անցնել մաքսայինը',
    },
    'about-text7': {
        'ru': 'и сделать прохождение таможни более выгодным.',
        'us': 'we can provide customs clearance on more favorable terms.',
        'am': 'եւ դարձնել անցումը մաքսային ավելի շահավետ.',
    },


    'faq-title': {
        'ru': 'Нас часто спрашивают',
        'us': 'Frequently asked questions',
        'am': 'Մեզ հաճախ հարցնում են',
    },
    'faq-q1': {
        'ru': 'Зачем покупать автомобиль за границей?',
        'us': 'Why should we buy cars abroad?',
        'am': 'Ինչու՞ մեքենան գնել արտասահմանում:',
    },
    'faq-a1': {
        'ru': '              Мы живем в современном мире, с хорошо продуманными логистическими цепочками. Международные\n' +
            '              интернет-магазины набирают популярность, а границы доставки товаров постепенно стираются. Мы тоже\n' +
            '              продумали весь процесс выкупа и доставки автомобиля: наладили связи, оптимизировали стоимость, разобрались\n' +
            '              во всех юридических аспектах. У покупки автомобилей за рубежом есть ощутимые преимущества:\n' +
            '              <ol class="faq__item-list">\n' +
            '                <li>\n' +
            '                  Российские официальные дилеры точно так же оплачивают таможенные пошлины, получают сертификаты и\n' +
            '                  оформляют другие документы. Поэтому окончательная стоимость автомобилей примерно одинакова.\n' +
            '                </li>\n' +
            '                <li>Вам не придется переплачивать дилерскую наценку и довольствоваться только “российскими” сборками\n' +
            '                  авто.</li>\n' +
            '                <li>Модели, которые продаются за рубежом, оснащаются передовыми системами, более мощными и экологичными\n' +
            '                  двигателями.</li>\n' +
            '                <li>В случае с покупкой подержанного автомобиля. вы узнаете его полную историю, во всех подробностях.</li>\n' +
            '                <li>Все процессы, связанные с доставкой, мы берем на себя. Кроме того, помогаем с оформлением и\n' +
            '                  регистрацией машины уже в России.</li>\n' +
            '                <li>У вас практически нет ограничений по марке и модели. Выбирайте любой автомобиль, даже если\n' +
            '                  производитель никогда не поставлял его в Россию.</li>\n' +
            '              </ol>',
        'us': 'Our modern world has well developed supply chains. Global online stores become more popular with the delivery barriers gradually disappearing.\n' +
            'We have thoroughly planned the entire process of car buying and delivery, established necessary contacts, optimized the price, gained insight into details of all legal aspects. Buying cars abroad has distinct advantages.\n' +
            '<ol class="faq__item-list">\n' +
            '    <li>Official dealers pay customs duties, obtain certificates and other documents exactly in the same way. Thus, the\n' +
            '        final car price is almost similar.\n' +
            '    </li>\n' +
            '    <li>There is no need to pay extra to dealers.</li>\n' +
            '    <li>Cars from abroad are equipped with advanced systems, more powerful and eco-friendly engines.</li>\n' +
            '    <li>When buying a used car, you will aware of its whole history and every detail.</li>\n' +
            '    <li>We are solely responsible for all delivery-related issues. We will help you to prepare all documents and\n' +
            '        register the car.\n' +
            '    </li>\n' +
            '    <li>We are restricted to neither brands not models.</li>\n' +
            '</ol>',
        'am': 'Մենք ապրում ենք ժամանակակից աշխարհում, լավ մտածված մատակարարման շղթաներով: Միջազգային առցանց խանութները դառնում են ավելի հարգի, իսկ ապրանքների առաքման սահմանները աստիճանաբար ջնջվում են։ Մենք նաև մտածեցինք մեքենայի գնման և առաքման ողջ գործընթացի մասին. կապեր հաստատեցինք, օպտիմիզացրեցինք ծախսերը և պատկերացում կազմեցինք բոլոր իրավական ասպեկտների մասին: Արտերկրում մեքենաներ գնելը շոշափելի առավելություններ ունի.\n' +
            '<ol class="faq__item-list">\n' +
            '    <li>Պաշտոնական դիլերները նույն կերպ վճարում են մաքսատուրքերը, ստանում սերտիֆիկատներ և ձևակերպում այլ փաստաթղթեր։ Հետևաբար, մեքենաների վերջնական արժեքը մոտավորապես նույնն է։</li>\n' +
            '    <li>Դուք ստիպված չեք լինի վճարել դիլերային հավելավճար։</li>\n' +
            '    <li>Արտասահմանում վաճառվող մոդելները հագեցած են առաջադեմ համակարգերով, ավելի հզոր և էկոլոգիապես մաքուր շարժիչներով։</li>\n' +
            '    <li>Օգտագործված մեքենա գնելու դեպքում դուք կիմանաք դրա ողջ պատմությունը՝ բոլոր մանրամասներով:</li>\n' +
            '    <li>Մենք հոգում ենք առաքման հետ կապված բոլոր գործընթացները։ Բացի այդ, մենք օգնում ենք մեքենայի ձևակերպման և գրանցման հարցում:</li>\n' +
            '    <li>Դուք գրեթե սահմանափակումներ չունեք մակնիշի և մոդելի հարցում:</li>\n' +
            '</ol>\n',
    },

    'faq-q2': {
        'ru': ' Как это всё происходит?',
        'us': 'How does it happen?',
        'am': 'Ինչպե՞ս է այդ ամենը տեղի ունենում:',
    },
    'faq-a2': {
        'ru': '           Если опустить формирование и согласование бюджета, то покупка проходит в три этапа:\n' +
            '              <ol class="faq__item-list">\n' +
            '                <li>Поиск и выкуп.</li>\n' +
            '                <li>Доставка до таможни РФ и прохождение всех процедур оформления.</li>\n' +
            '                <li>Доставка до вашего местоположения или точки, оговоренной в договоре.</li>\n' +
            '              </ol>',
        'us': 'The car buying process comprises 3 stages (apart from budget development and approval):\n' +
            '<ol class="faq__item-list">\n' +
            '    <li>Car searching and buying</li>\n' +
            '    <li>Delivery and customs clearance</li>\n' +
            '    <li>Delivery to your location or the place of destination specified in the contract</li>\n' +
            '</ol>',
        'am': 'Եթե բաց թողնենք բյուջեի ձևավորումն ու համաձայնեցումը, ապա գնումը տեղի է ունենում երեք փուլով.\n' +
            '<ol class="faq__item-list">\n' +
            '    <li>Որոնում և գնում</li>\n' +
            '    <li>Առաքում մաքսատուն և մաքսազերծման բոլոր ընթացակարգերի անցում</li>\n' +
            '    <li>Առաքում պայմանագրում նշված ձեր գտնվելու վայր կամ կետ</li>\n' +
            '</ol>',
    },
    'faq-q3': {
        'ru': 'Из чего формируется стоимость растаможки?',
        'us': 'What does customs duties cost depend on?',
        'am': 'Ինչի՞ց է ձևավորվում մաքսազերծման արժեքը',
    },
    'faq-a3': {
        'ru': 'В первую очередь на эту сумму влияют объем двигателя и год выпуска. Стоит учитывать, что новые автомобили обходятся дешевле при таможенной очистке. Наши специалисты помогут рассчитать все необходимые затраты заранее.',
        'us': 'First of all, the cost depends on the engine power and year of manufacture. It should be noted that the customs duties for a new car are lower. Our experts will help you to calculate the necessary expenses in advance.',
        'am': 'Առաջին հերթին, այս գումարի վրա ազդում են շարժիչի ծավալը և արտադրության տարին։  Հարկ է հաշվի առնել, որ նոր մեքենաներն ավելի էժան են մաքսազերծման ժամանակ։ Մեր մասնագետները կօգնեն նախապես հաշվարկել բոլոր անհրաժեշտ ծախսերը:',
    },
    'faq-q4': {
        'ru': 'Какие риски?',
        'us': 'What risks exist?',
        'am': 'Որո՞նք են ռիսկերը:',
    },
    'faq-a4': {
        'ru': 'Рисков практически нет. Мы досконально проработали несколько вариантов доставки автомобиля из разных стран мира.',
        'us': 'There are almost no risks. We have thoroughly developed several options for car delivery from different countries of the world.',
        'am': 'Գործնականում ռիսկեր չկան։ Մենք մանրակրկիտ մշակել ենք մի քանի տարբերակ աշխարհի տարբեր երկրներից ավտոմեքենա առաքելու համար',
    },
    'faq-q5': {
        'ru': 'Какой автомобиль я могу заказать?',
        'us': 'What car can I order?',
        'am': 'Ին՞չ մեքենա կարող եմ պատվիրել:',
    },
    'faq-a5': {
        'ru': 'Абсолютно любой. Новый, подержанный, поврежденный, затопленный. Многие клиенты экономят на том, что восстанавливают поврежденные автомобили. Их цена на аукционе намного ниже, чем у лотов с пробегом, без повреждений или других пятен в истории. В случае с поврежденным авто, мы поможем найти запчасти и выполнить ремонт в профильном сервисе. Сумму технических работ определим индивидуально.',
        'us': 'I can order a new, used, damaged or submerged car. Many customers save money and restore damaged cars. The price of a damaged car at auction is much lower than of a used one having no damages or accident history. If the car is damaged, we\'ll help you to find spare parts and repair it at a specialized repair shop. The price of repairing works will be calculated on an individual basis.',
        'am': 'Բացարձակապես ցանկացած: Նոր, օգտագործված, վնասված, ողողված: Շատ հաճախորդներ խնայում են՝ վնասված մեքենաները վերականգնում են: Աճուրդում դրանց գինը շատ ավելի ցածր է, քան օգտագործված լոտերը, առանց վնասների կամ պատմության այլ բծերի: Վնասված մեքենայի դեպքում մենք կօգնենք գտնել պահեստամասեր և վերանորոգել մասնագիտացված տեխնիկական կայանում: Տեխնիկական աշխատանքների գումարը որոշվում է անհատապես',
    },

    'faq-q6': {
        'ru': 'Как формируется цена автомобиля?',
        'us': 'What is included in the car price?',
        'am': 'Ինչպե՞ս է ձևավորվում մեքենայի գինը:',
    },
    'faq-a6': {
        'ru': 'Существует несколько критериев ценообразования, это:\n' +
            '              <ol class="faq__item-list">\n' +
            '                <li>Стоимость в месте выкупа.</li>\n' +
            '                <li>Комиссия аукциона.</li>\n' +
            '                <li>Потребность в ремонте.</li>\n' +
            '                <li>Доставка.</li>\n' +
            '                <li>Таможенные сборы.</li>\n' +
            '                <li>Получение документов.</li>\n' +
            '                <li>Услуги нашей компании.</li>\n' +
            '              </ol>',
        'us': 'The pricing criteria include:\n' +
            '<ol class="faq__item-list">\n' +
            '\t<li>The selling price</li>\n' +
            '\t<li>Auction fees</li>\n' +
            '\t<li>Repair costs</li>\n' +
            '\t<li>Delivery</li>\n' +
            '\t<li>Customs duties</li>\n' +
            '\t<li>Document obtaining</li>\n' +
            '\t<li>Fees for our services</li>\n' +
            '</ol>',
        'am': 'Գնագոյացման մի քանի չափանիշներ կան, Դրանք են:\n' +
            '<ol class="faq__item-list">\n' +
            '\t<li>Արժեքը գնման վայրում;</li>\n' +
            '\t<li>Աճուրդի միջնորդավճարը;</li>\n' +
            '\t<li>Վերանորոգման անհրաժեշտությունը;</li>\n' +
            '\t<li>Առաքումը;</li>\n' +
            '\t<li>Մաքսային վճարները;</li>\n' +
            '\t<li>Փաստաթղթերի ստացումը;</li>\n' +
            '\t<li>Մեր ընկերության ծառայությունները:</li>\n' +
            '</ol>',
    },
    'faq-q7': {
        'ru': 'За сколько вы доставите автомобиль?',
        'us': 'How long does the car delivery take?',
        'am': 'Որքանո՞վ եք առաքում մեքենան:',
    },
    'faq-a7': {
        'ru': 'Срок доставки, как правило, варьируется от 30 до 90 суток. Это связано со способом покупки, страной, оформлением документов, транспортировкой океаном и по суше.',
        'us': 'As a rule, the delivery period ranges from 30 to 90 days. It depends on the purchase procedure, country, document preparation, transportation by water and land.',
        'am': 'Առաքման ժամանակը, որպես կանոն, տատանվում է 30-ից 90 օր: Դա պայմանավորված է գնման եղանակով, երկիրով, թղթաբանությամբ, օվկիանոսային և ցամաքային փոխադրումներով:',
    },
    'faq-a8': {
        'ru': 'Доставим автомобиль в любой населенный пункт нашей страны. Это может быть город, посёлок или даже деревня.',
        'us': 'We will deliver the car to any Russian city, settlement or village.',
        'am': 'Մեքենան կհասցնենք մեր երկրի ցանկացած բնակավայր։ Դա կարող է լինել քաղաք, ավան կամ նույնիսկ գյուղ:',
    },
    'faq-q9': {
        'ru': 'А как быть с запчастями?',
        'us': 'What about spare parts?',
        'am': 'Իսկ ի՞նչ անել պահեստամասերի հետ:',
    },
    'faq-a9': {
        'ru': 'Мы помогаем приобрести запасные части для вашего автомобиля, даже если они очень редкие.',
        'us': 'We help to purchase spare parts, even those which are hardest to find.',
        'am': 'Մենք օգնում ենք ձեր մեքենայի համար ձեռք բերել պահեստամասեր, նույնիսկ եթե դրանք շատ հազվադեպ են:',
    },
    'faq-q10': {
        'ru': 'Не могу понять, какой автомобиль мне нужен',
        'us': 'I don’t know what car I need',
        'am': 'Չեմ կարողանում հասկանալ, թե ինչ մեքենա է ինձ պետք',
    },
    'faq-a10': {
        'ru': 'Мы поможем выделить наиболее важные критерии: марку, тип, мощность двигателя, коробку передач, комплектацию, стоимость. Оставьте заявку на сайте или позвоните по номеру, указанному на сайте.',
        'us': 'We advise you on the most important criteria: car brand, type, engine power, gearbox, options packages, price. Fill in the application form on our website or call on the specified number.',
        'am': 'Մենք կօգնենք առանձնացնել ամենակարևոր չափանիշները՝ մակնիշը, տեսակը, շարժիչի հզորությունը, փոխանցման տուփը, սարքավորումները, արժեքը:  Հայց թողեք կայքում կամ զանգահարեք կայքում նշված համարին:',
    },
    'faq-q11': {
        'ru': 'Могу ли я сам забрать автомобиль на границе без доставки?',
        'us': 'Can I pick up the car at the border without delivery?',
        'am': 'Կարո՞ղ եմ ինքս սահմանին մեքենան վերցնել՝ առանց առաքման:',
    },
    'faq-a11': {
        'ru': 'Конечно. Мы обсудим конечную точку доставки вашего автомобиля на стадии формирования договора.',
        'us': 'Surely! We will discuss the place of destination at the stage of contract preparation.',
        'am': 'Իհարկե: Մենք կքննարկենք Ձեր մեքենայի առաքման վերջնական կետը պայմանագրի ձևավորման փուլում:',
    },

    'modal-title': {
        'ru': 'Заявка на подбор',
        'us': 'Application for a car selection',
        'am': 'Ընտրության հայտ',
    },
    'modal-thanks': {
        'ru': 'Заявка успешно отправлена!',
        'us': 'Your request has been sent successfully',
        'am': 'Դիմումը հաջողությամբ ուղարկվել է:',
    },
    'modal-subtitle': {
        'ru': 'Заполните заявку на подбор автомобиля',
        'us': 'Fill in the application for a car selection',
        'am': 'Լրացրեք հայտ մեքենայի ընտրության համար',
    },
    'modal-select-name': {
        'ru': 'Состояние',
        'us': 'Car condition',
        'am': 'Վիճակը',
    },
    'modal-select-1': {
        'ru': 'Новый',
        'us': 'A new car',
        'am': 'Նոր',
    },
    'modal-select-2': {
        'ru': 'Подержанный',
        'us': 'A used car',
        'am': 'Օգտագործված',
    },
    'modal-select-3': {
        'ru': 'Любое',
        'us': 'Anyone',
        'am': 'Ցանկացած',
    },
    'modal-privacy': {
        'ru': 'Отправляя заявку, Вы соглашаетесь с <a href="/privacy" target="_blank" rel="noopener">Условиями обработки персональных данных</a>',
        'us': 'By submitting an application, you agree to <a href="/privacy-en" target="_blank" rel="noopener">the Terms and Conditions of personal data processing</a>',
        'am': 'Հայտ ներկայացնելով, <a href="/privacy-am" target="_blank" rel="noopener">դուք համաձայնում եք անձնական տվյալների մշակման Պայմաններին</a>',
    },


    'form-privacy': {
        'ru': 'Отправляя заявку, Вы соглашаетесь с <a href="/privacy" target="_blank" rel="noopener">Условиями обработки персональных данных</a>',
        'us': 'By submitting an application, you agree to <a href="/privacy-en" target="_blank" rel="noopener">the Terms and Conditions of personal data processing</a>',
        'am': 'Հայտ ներկայացնելով, <a href="/privacy-am" target="_blank" rel="noopener">դուք համաձայնում եք անձնական տվյալների մշակման Պայմաններին</a>',
    },
    'form-select-name': {
        'ru': 'Состояние',
        'us': 'Car condition',
        'am': 'Վիճակը',
    },
    'form-select-1': {
        'ru': 'Новый',
        'us': 'A new car',
        'am': 'Նոր',
    },
    'form-select-2': {
        'ru': 'Подержанный',
        'us': 'A used car',
        'am': 'Օգտագործված',
    },
    'form-select-3': {
        'ru': 'Любое',
        'us': 'Anyone',
        'am': 'Ցանկացած',
    },
    'form-brand-name': {
        'ru': 'Марка авто*',
        'us': 'Car brand',
        'am': 'Մեքենայի մակնիշը*',
    },
    'form-title': {
        'ru': 'Я ищу',
        'us': 'I\'m searching',
        'am': 'Ես փնտրում եմ',
    },

    'politics': {
        'ru': '<a href="/privacy" target="_blank" rel="noopener" class="footer__text footer__privacy" data-text-item="politics">Политика конфиденциальности</a>',
        'us': '<a href="/privacy-en" target="_blank" rel="noopener" class="footer__text footer__privacy" data-text-item="politics">Privacy Policy</a>',
        'am': '<a href="/privacy-am" target="_blank" rel="noopener" class="footer__text footer__privacy" data-text-item="politics">Գաղտնիության քաղաքականություն</a>',
    },

    'map-work-hours': {
        'ru': 'Пн - Вс: 09:00 - 21:00',
        'us': 'Mon - Sun: 09:00 - 21:00',
        'am': 'Երկ-Կիր: 09:00-21:00',
    },
    'map-address': {
        'ru': 'г. Ереван, улица Паруйра Севака, дом 30',
        'us': 'Yerevan, Paruyra Sevak street, 30',
        'am': 'Երևան, Պարույր Սևակի փողոց, 30',
    },
    'map-title': {
        'ru': 'Контакты',
        'us': 'Contacts',
        'am': 'Հետադարձ կապ',
    },

    'p-modal-budget': {
        'ru': 'Бюджет',
        'us': 'Budget',
        'am': 'Բյուջե',
    },
    'p-modal-brand-model': {
        'ru': 'Марка и модель*',
        'us': 'Car brand and model*',
        'am': 'Մեքենայի մակնիշը և մոդելը*',
    },
    'p-modal-comment': {
        'ru': 'Комментарий',
        'us': 'Comments',
        'am': 'Մեկնաբանություն',
    },
    'p-modal-name': {
        'ru': 'Имя*',
        'us': 'Name*',
        'am': 'Անուն*',
    },

};
